<template>
  <modal-form class="nest-form-modal mymodal">
    <!-- title -->
    <span class="card-header-title is-flex-center" slot="header" v-if="parsedData.length > 0">
      <control-button class="is-primary " @click="savePreset">Save Preset</control-button>
    </span>

    <!-- footer -->
    <div slot="footer" class="has-width-100per " :class="parsedData.length > 0? 'level-right':'level-left'">
      <control-button class="is-outlined is-background-transparent is-small dangerBorder" @click="$parent.close()">Cancel</control-button>
      <control-button class="is-primary is-small" :disabled="!parsedData.length > 0" @click="submit" :loading="saving" v-if="parsedData.length > 0">Import</control-button>
    </div>

    <template slot="body">
      <div class="instruction" v-if="!parsedData.length > 0">
       <decor-title class="titleCsv">Import CSV</decor-title>
        <div class="step">
          <span>Step 1</span>
          <a @click="downloadCsv">Download “Stacks Import Template”</a>
          <!-- <download-excel
            :fields="importField"
            type="xls"
            name="stacks_import_template.xls"
            :data="importData"
            >
            <a>Download “Stacks Import Template”</a>
            </download-excel
          > -->
        </div>
        <div class="step">
          <span>Step 2</span>
          <p>Enter client info beginning on row 2 </p>
        </div>
        <div class="step">
          <span>Step 3</span>
          <p>Save As .csv file and upload your file below</p>
        </div>
      </div>
      <div class="is-flex-center">
        <div class="propertyContainer" v-if="parsedData.length > 0">
          <div class="csvProperty">
            <control-button
              v-for="name in Object.keys(parsedData[0])"
              v-if="csvProperties.indexOf(name) !== -1"
              :key="name"
              style="margin-top:10px;"
              class="btnM"
            >{{name}}</control-button>
          </div>
          <div class="selectorProperty">
            
              <b-select placeholder="Select" v-for="(name, index) in Object.keys(parsedData[0])" :key="index" class="selector" v-model="selectionModel[name]" v-if="csvProperties.indexOf(name) !== -1">
                <option
                  v-for="option in dbProperties"
                  :value="option.value"
                  :key="option.value"
                >{{ option.name }}</option>
              </b-select>
            
          </div>
        </div>
        <div v-else class="uploadContainer">
          <b-upload v-model="csvFile" drag-drop accept=".csv, text/csv" @input="parseCsv">
            <section class="section is-flex-center">
              <div class="content has-text-centered is-flex-center">
                <p>
                  <b-icon pack="fas" icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your CSV file here or click to upload</p>
              </div>
            </section>
          </b-upload>
        </div>
      </div>
    </template>
  </modal-form>
</template>

<script>
import Papa from "papaparse";
import { dangerBar, successBar } from "@/lib/notif";
import { db, storage } from "@/module/firebase";
import store from "@/store";
import defaultPreset from '../default_preset'

export default {
  name: "ToolPopup",
  components: {},
  props: {},
  data() {
    return {
      link2:'https://expectful.com/wp-content/uploads/2020/02/stacks_import_template.csv',
      link1:'https://firebasestorage.googleapis.com/v0/b/stacks-e2674.appspot.com/o/Import%2Fstacks_import_template.csv?alt=media&token=1b51cd04-9378-4544-b4fe-6e5b12a58393',
      // link:'https://firebasestorage.googleapis.com/v0/b/stacks-e2674.appspot.com/o/Import%2Fstacks_import_template.csv?alt=media&token=1b51cd04-9378-4544-b4fe-6e5b12a58393',
      saving: false,
      csvFile: null,
      parsedData: [],
      csvProperties : [ 'Name', 'Street', 'City', 'State', 'Zip Code', 'Phone', 'Email'],
      selectionModel: [],
      preset: {},
      importField:{
        'Name':'name', 'Street':'street', 'City':'city', 'State':'state', 'Zip Code':'zipcode', 'Phone':'phone', 'Email':'email'

      },
      importData:[{
        'name':'',
        'street':'',
        'city':'',
        'state':'',
        'zipcode':'',
        'phone':'',
        'email':''
      }]
    };
  },
  computed: {
    dbProperties(){
      return require('../import_columns').default
    }
  },
  methods: {
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = link
      link.setAttribute('download', 'stacks_import_template.csv') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadCsv() {
  var element = document.createElement('a');
element.setAttribute('href', 'data:application/octet-stream;base64,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');
element.setAttribute('download', 'Stacks Import Template.xlsm');
document.body.appendChild(element);
element.click();
document.body.removeChild(element)
      // this.$http({
      //   method: 'get',
      //   url: this.link,
      //   responseType: 'arraybuffer',
    

      // })
      // .then(response => {
      //   this.forceFileDownload(response)  
      // })
      // .catch((e) => console.log(e))

      // var link = document.createElement('a');
      // // в url вставляєш лінк звідки качається файл
      // link.setAttribute('href', this.link);
      // link.setAttribute('download', 'file');
      // link.click();
      
    },
    
    parseCsv() {
      let self = this;
      self.parsedData = [];

      Papa.parse(self.csvFile, {
        header: true,
        skipEmptyLines: true,
        step: function(row) {
          self.parsedData.push(row.data);
          console.log(row.data)
        },
        complete: async function() {
          self.csvFile = null;
          // self.parsedData.pop();
          self.parsedData.map(obj => {
            Object.keys(obj).map(key => {
              obj[key] = obj[key].replace(/["=\\]/g, "");
            });
          });
          console.log(self.parsedData)
          for(let i = self.parsedData.length - 1; i >= 0; i--){
            let areAllEmptyFields = true
            Object.keys(self.parsedData[i]).map(key => {
              if(self.parsedData[i][key]) areAllEmptyFields = false
            })
            if(areAllEmptyFields) self.parsedData.splice(i, 1)
          }
          console.log(self.parsedData)
          Object.keys(self.parsedData[0]).map(key => {
            if(self.csvProperties.indexOf(key) !== -1)
              self.selectionModel[key] = null
          })
          if(Object.keys(self.preset).length > 0){
            Object.keys(self.preset).map(p => {
              if(Object.keys(self.selectionModel).indexOf(p) !== -1){
                self.selectionModel[p] = self.preset[p]
              }
            })
          }else{
            Object.keys(defaultPreset).map(p => {
              if(Object.keys(self.selectionModel).indexOf(p) !== -1){
                self.selectionModel[p] = defaultPreset[p]
              }
            })
          }
        },
        error: function(error) {
          self.showMessagePopup(error.message);
          self.csvFile = null;
        }
      });
    },
    submit(){
      try{
        const uid = store.state.searchClientsByUser.id;
        var isEmpty = true
        Object.keys(this.selectionModel).map(key => {
          if(this.selectionModel[key]) isEmpty = false
        })
        if(isEmpty){
          dangerBar('You have to select at least one field')
          return false;
        }
        this.saving = true
        Promise.all(
          this.parsedData.map(async (data) => {
            var model = {}
            Object.keys(this.selectionModel).map(key => {
              if(this.selectionModel[key] && data[key]){
                if(data[key] === 'true' || data[key] === 'false'){
                  model[this.selectionModel[key]] = data[key] === 'true'
                }
                
                // else if(!Number.isNaN(Number(data[key]))){
                //   model[this.selectionModel[key]] = Number(data[key])
                else{
                  model[this.selectionModel[key]] = data[key]
                }
              }
            })
           
            var newClientKey = db.ref().child(`/clients/${uid}`).push().key;
             console.log({
              id: newClientKey,
              ...model
            })
            await db.ref(`/clients/${uid}/${newClientKey}`).set({
              id: newClientKey,
              country:"USA",
              isNotificationEnabled:false,
              isPitched:false,
              referral:0,
              split:100,
              coBrokeIsSelected:false,
              showingType:'',
              lastUpdate:new Date().getTime(),
              ...model
            })
          }))
          this.saving = false
          this.$parent.close()
          this.$emit('reload')
      }catch(e){
        this.saving = false
        console.log(e)
        dangerBar('There was an error')
      }
    },
    async savePreset(){
      try{
        const uid = store.state.searchClientsByUser.id;
        await db.ref(`/presets/${uid}`).set({
          preset: this.selectionModel
        })
        successBar('Preset was saved')
      }catch(e){
        dangerBar('There was an error saving preset')
      }
    },
    async setPreset(){
      var self = this
      const uid = store.state.searchClientsByUser.id;
      const result = await db.ref(`/presets/${uid}`).once("value").then(res => res.val())
      this.preset = result ? result.preset : {}
      console.log(this.preset)

    }
  },
  async created(){
    const uid = store.state.searchClientsByUser.id;
    var result = await db.ref(`/clients/${uid}`).once("value");
    var clients = result.val() ? Object.values(result.val()) : [];
    var fullClient = {}
    clients.map(c => fullClient = {...fullClient, ...c})
    this.fullClient = fullClient
    await this.setPreset()
  }
};
</script>
<style>

</style>
<style lang="scss" scoped>
.mymodal{
  border-radius: 8px;
}
.titleCsv{
  color:black !important;
  font-weight: bold;
}
.dangerBorder{
  border-color: #DFE3E8
}
.uploadContainer{
  display: flex;
  justify-content: center
}
.selectorProperty{
  display:flex;
    flex-direction: column

}
.propertyContainer{
  display:flex;
  flex-direction: row;
  justify-content: space-around;
}
.csvProperty{
  display:flex;
  flex-direction: column
}
.clear {
  margin: 0;
  outline: none;
  border: none;
}
.btnM {
  margin-top: 10px;
}
.right {
  display: flex;
  flex-direction: column;
}
.right span {
  margin-top: 10px;
  text-align: right;
}
.selector {
  margin-top: 10px;
}
.test {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.upload-button {
  padding: 50px 30px;
}
.plus-icon {
  color: #dfe3e8;
  font-weight: 300;
}
.image-edit {
  display: flex;
  flex-direction: column;
}
.image-container {
  width: 110px;
  height: 110px;
}
.image-container img {
  height: 100% !important;
}
.deleteLink {
  color: #d0021b;
  font-size: 0.75rem;
}
.croppa-size {
  width: 200px;
}
.instruction{
  display:flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 35px;
  .step{
    margin-top:25px;
    display: flex;
    align-items: center;
    span{
      font-size: 20px;
    }
    a{
      margin-left:40px;
    }
    p{
      margin-left:40px; 
    }
    &:nth-child(2){
  margin-top:10px;

    }
    
  }
}


</style>
